export default __webpack_public_path__ + "static/media/cyber.e7ceed9f.jpg";